<template>
    <transition name="fade">
      <!--  #BR#74 - Mbeng Atemson - Become a Broker Request  - 09/04/2025 -->
      <div
        v-if="visible"
        class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
      >
        <div class="bg-white rounded-xl shadow-xl w-full max-w-md p-6 relative">
          <button
            @click="$emit('close')"
            class="absolute top-3 right-3 text-gray-400 hover:text-black"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none"
              viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
          
          <div class="text-center mb-4">
            <img src="@/assets/icm-logo.svg" alt="ICM.com" class="mx-auto h-8" />
        </div>

          <h2 class="text-xl font-semibold mb-4">{{$t("become-an-introducing-broker")}}</h2>
  
          <p class="text-gray-600 mb-4">
            <!-- Interested in becoming an introducing broker? Fill in your details and our team will get back to you. -->
            {{$t("interested-in-becoming-an-introducing-broker")}}
          </p>
  
          <form @submit.prevent="submitForm">
          <div class="mb-4">
            <label class="block text-sm font-medium text-gray-700 mb-1">
              <!-- Number of expected referred clients  -->
              {{$t("number-of-expected-referred-clients")}}
            </label>
            <input
              v-model.number="form.referredClients"
              type="number"
              min="1"
              max="1000"
              placeholder="e.g. 5"
              class="w-full border border-gray-300 rounded-md shadow-sm px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-200"
              required
            />
          </div>

          <div class="mb-4">
            <label class="block text-sm font-medium text-gray-700 mb-1">
              <!-- Expected total net deposit in the first month  -->
              {{$t("expected-total-of-net-deposit")}}
            </label>
            <input
              v-model.number="form.netDeposit"
              type="number"
              min="1"
              max="1000000"
              placeholder="e.g. 10000"
              class="w-full border border-gray-300 rounded-md shadow-sm px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-200"
              required
            />
          </div>
         <!-- # #BR#88 Mbeng Become a broker request icmvc 18/05/2025 -->
          <div class="mb-4 flex items-start">
              <input
                v-model="form.agree"
                type="checkbox"
                id="agree"
                class="mt-1 mr-2"
                required
              />
              <label for="agree" class="text-sm text-gray-700">
                <!-- I agree to the  -->
                {{$t("i-agree-to-the")}}
                <a
                  :href="computedPdfUrl || null"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="text-blue-600 hover:underline { 'pointer-events-none opacity-50': !computedPdfUrl }"
                >
                  <!-- Terms and Conditions  -->
                  {{$t("terms-and-conditions")}}
                </a>
              </label>
            </div>

          <button
            type="submit"
            class="w-full bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium py-2 px-4 rounded-md"
          >
          {{ $t("Submit") }}
          </button>
        </form>
        </div>
      </div>
    </transition>
  </template>
  
  <script>
  import { mapGetters } from "vuex";

  export default {
    name: 'BecomeABrokerPopup',
    props: {
      visible: {
        type: Boolean,
        required: true,
      },
    },
    data() {
      return {
        form: {
            referredClients: null,
            netDeposit: null,
            agree: false,
        },
      };
    },
    methods: {
        
      async submitForm() {
    //console.log("User Info:", this.get_profile);

    // Validate referredClients and netDeposit
    if (
        !this.form.referredClients || this.form.referredClients <= 0 ||
        !this.form.netDeposit || this.form.netDeposit <= 0
    ) {
        alert("Please enter valid positive numbers for all fields.");
        return;
    }

    // Confirmation prompt
    const confirmed = confirm("Are you sure you want to submit this form?");
    if (!confirmed) return;

    // Prepare payload
    const payload = {
        whitelabel: process.env.VUE_APP_WHITELABEL,  // <-- get from env
        id: this.get_profile.id,
        username: this.get_profile.username,
        first_name: this.get_profile.first_name,
        last_name: this.get_profile.last_name,
        email: this.get_profile.email,
        referred_clients: this.form.referredClients,
        net_deposit: this.form.netDeposit,
        agreed_to_terms: this.form.agree,
    };

    try {
        //Use environment variable for base URL
        const apiBase = process.env.VUE_APP_API_URL;
        const response = await fetch(`${apiBase}accounts/become-broker/`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
        });

        // Handle non-2xx responses
        if (!response.ok) {
            const errorData = await response.json();
            //console.error("Failed:", errorData);
            alert("Submission failed. Please try again.");
            return;
        }

        //Trigger success event and reset form
        this.$emit('submit', payload);

        this.form = {
            referredClients: null,
            netDeposit: null,
            agree: false,
        };

        this.$emit('close');

    } catch (error) {
        //console.error("Error submitting form:", error);
        alert("An unexpected error occurred.");
    }
},

  },

  computed: {
    ...mapGetters(["get_profile"]),
    userLanguage() {
    return this.get_profile?.profile?.language;
  },
  
    computedPdfUrl() {
      //const lang = this.get_profile?.profile?.language || 'en';
      const lang = this.$store.getters.get_lang || 'en';  // ERR#75 - mbeng - 23/09/2025 - pdf selection based on page language

      const mapICMMU = {
        en: '/Introducing-Broker-Terms-and-Conditions-english.pdf',
        ar: '/Introducing-Broker-Terms-and-Conditions-arabic.pdf',
        es: '/Introducing-Broker-Terms-and-Conditions-spanish.pdf',
        pt: '/Introducing-Broker-Terms-and-Conditions-portugese.pdf',
        th: '/Introducing-Broker-Terms-and-Conditions-english.pdf',
        ms: '/Introducing-Broker-Terms-and-Conditions-malay.pdf',
        vi: '/Introducing-Broker-Terms-and-Conditions-english.pdf',
        id: '/Introducing-Broker-Terms-and-Conditions-english.pdf',
      };

      const mapICMVC = {
        en: '/Introducing-Broker-Terms-and-conditions-vc-en.pdf',
        ar: '/Introducing-Broker-Terms-and-conditions-vc-ar.pdf',
        es: '/Introducing-Broker-Terms-and-conditions-vc-en.pdf',
        pt: '/Introducing-Broker-Terms-and-conditions-vc-en.pdf',
        th: '/Introducing-Broker-Terms-and-conditions-vc-en.pdf',
        ms: '/Introducing-Broker-Terms-and-conditions-vc-en.pdf',
        vi: '/Introducing-Broker-Terms-and-conditions-vc-en.pdf',
        id: '/Introducing-Broker-Terms-and-conditions-vc-en.pdf',
      };

      const mapICMSC = {
        en: '',
        ar: '',
        es: '',
        pt: '',
        th: '',
        ms: '',
        vi: '',
        id: '',
      };

      const whitelabel = process.env.VUE_APP_WHITELABEL;

      if (whitelabel === 'ICMMU') {
        return mapICMMU[lang] || mapICMMU.en;
      } else if (whitelabel === 'ICMVC') {
        return mapICMVC[lang] || mapICMVC.en;
      } else if (whitelabel === 'ICMSC') {
        return mapICMSC[lang] || mapICMSC.en;
      }

      return mapICMMU.en; // fallback

      // return process.env.VUE_APP_WHITELABEL === 'ICMMU'
      //   ? mapICMMU[lang] || mapICMMU.en
      //   : mapICMVC[lang] || mapICMVC.en;
    }
  },
  };
  </script>
  
  <style scoped>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s ease;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
  </style>
  